module.exports = __webpack_public_path__ + "img/tpc-web-2.2828cac0.webp";